import ApiService from '@/services/core/api.service'

const CropFieldSizeService = {
  async get (query) {
    return ApiService.get(`admin/crop-field-sizes?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/crop-field-sizes', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/crop-field-sizes/${payload.id}`, payload)
  }
}

export default CropFieldSizeService
